import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <ContactSection />
        <AboutSection />
        <CardsSection />
        <UpdatesSection />
        <RankingSection />
        <IndexSection />
        <MediaSection />
        <AppSection />
        <CarouselSection />
        <CommentsSection />
        <TopicsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
}